import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  FinancialTransactionsListComponent
} from './financial-transactions-list/financial-transactions-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: FinancialTransactionsListComponent,
        data: {
          title: 'Financial Transactions'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinancialTransactionsRoutingModule {
}
